import { render } from "./TaskRow.vue?vue&type=template&id=0fc223da&scoped=true"
import script from "./TaskRow.vue?vue&type=script&lang=js"
export * from "./TaskRow.vue?vue&type=script&lang=js"

import "./TaskRow.vue?vue&type=style&index=0&id=0fc223da&scoped=true&lang=scss"

import exportComponent from "/home/tabelka-front/tabelka.expansja.pl/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fc223da"]])

export default __exports__